// Gatsby requirements
import React, { useState, useEffect, useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichText from "utils/RichTextRenderer"
import Image from "utils/Image"

// Styles
import * as CSS from './Staff.module.scss'


const Staff = ({ data }) => {

    // All of this enables the carousel and its navigation dots
    // I just copy pasted it from the docs: https://www.embla-carousel.com/api/
    const [viewportRef, embla] = useEmblaCarousel({
        align: "start",
        loop: "true",
        skipSnaps: false
    });
    const [selectedIndex, setSelectedIndex] = useState(0);
  
    const scrollTo = useCallback((index) => embla && embla.scrollTo(index), [
      embla
    ]);
  
    const onSelect = useCallback(() => {
      if (!embla) return;
      setSelectedIndex(embla.selectedScrollSnap());
    }, [embla, setSelectedIndex]);
  
    useEffect(() => {
      if (!embla) return;
      onSelect();
      embla.on("select", onSelect);
    }, [embla, onSelect]);

    return (
        <section
            className={`
                ${CSS.section}
                ${'section' + data._uid}    
            `}
            style={{
                backgroundColor: data?.backgroundColor,
                padding: data?.margin === 'Smaller: 0em top, 5em bottom' ? '0 0 5em 0' : ''
            }}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid).replaceAll('.top-text', '.top-text' + data._uid).replaceAll('.person', '.person' + data._uid)
                }} />
            }

            <div className={CSS.wrapper}>
                <div className={`
                    ${CSS.topText}
                    ${'top-text' + data._uid}
                `}>
                    <RichText content={data?.richText} />
                </div>

                <div className={`${CSS.list} ${data?.staffEntries?.length > 3 ? '' : CSS.noDrag}`}>
                    <div className="emabla" ref={viewportRef}>
                        <ul className="embla__container">
                            {data?.staffEntries?.map((loop, i) => (
                                <li key={i} className={`embla__slide ${'person' + data._uid}`}>
                                    <h3>{loop?.name}</h3>
                                    <p className={CSS.title}>{loop?.title}</p>
                                    <div className={CSS.tags}>
                                        {loop?.tags && loop.tags.split(',').map((tag, i) => (
                                            <span key={i}>{tag}</span>
                                        ))}
                                    </div>
                                    {loop?.image &&
                                        <Image img={loop.image} />
                                    }
                                    <RichText content={loop?.description} />
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className={`embla__dots ${data?.staffEntries?.length > 3 ? '' : CSS.hiddenOnDesktop}`}>
                        {data?.staffEntries?.map((loop, i) => (
                            <button
                                key={i}
                                onClick={() => scrollTo(i)}
                                className={`embla__dot ${i === selectedIndex ? "embla__dot_selected" : ""}`}
                                aria-label={`Go to slide ${i + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Staff